import http from 'common-module/src/util/http';
import { ChangeRecord, LabourRecord } from '../models/record';


// /issue/activity-list
export async function getIssueChangeRecord(
  id: number
): Promise<{
  showUpgradeLogo: boolean;
  days: Number;
  sysChangeGroupDetailVOList: ChangeRecord[];
}> {
  return http.post('/issue/activity-list-v2', {
    issueId: id
  }, {
    showError: false
  });
}

export async function getIssueLabourRecord(
  id: number
): Promise<LabourRecord[]> {
  return http.post('/labour-record/list', {
    issueId: id
  });
}
